import { FC } from 'react';
import LoaderIcon from '../../icons/loader.svg?react';

export const Loader: FC<{ width: number; height: number }> = ({
  width,
  height,
}) => (
  <div className="animate-spin [animation-duration:3s]">
    <LoaderIcon
      width={width}
      height={height}
    />
  </div>
);
